export default __webpack_public_path__ + "static/media/Artboard 14.fc4ee553.png";